import auth from './auth'
import master from './master'
import order from './order'
import partner from './partner'
import role from './role'
import admin from './admin'
import common from './common'
import armada from './armada'
import courier from './courier'
import hub from './hub'
import assignment from './assignment'
import merchant from './merchant'
import summary from './summary'
import notifications from './notifications'
import aichat from './ai-chat'

const api = {
  auth,
  master,
  order,
  partner,
  role,
  admin,
  common,
  armada,
  courier,
  hub,
  assignment,
  merchant,
  summary,
  notifications,
  aichat
}

export default api
